// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconApple = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M56 32C56 42.4832 49.3704 54 40 54C35.2998 54 34.6234 52 32 52C29.3766 52 28.7002 54 24 54C14.6296 54 8 42.4832 8 32C8 22.4362 13.4061 16 21 16C25.6907 16 27.462 16.874 29.1349 17.4665L28.3035 13.927C26.5485 14.1091 24.4623 13.9924 22.6399 12.9704C19.6244 11.2794 18.4493 7.73988 18.0402 5.9991C17.8857 5.3415 18.1808 4.84517 18.8444 4.64631C20.6011 4.12001 24.3447 3.33863 27.3601 5.02955C30.3756 6.72053 31.5507 10.2601 31.9598 12.0009C32.3688 13.7416 33.3418 17.884 33.3418 17.884C35.7444 17.4618 36.9327 16 43 16C50.5939 16 56 22.4362 56 32Z" />
    </svg>
  );
};
